import './GlanceHeader.css';

export interface GlanceHeaderProps {
  /** Real session data (the signed-in user's name) — never invented. */
  name: string;
  /** A read-only status line (union/market/etc). Omitted rather than
   *  faked when no real profile record backs it yet — see this
   *  component's own header. */
  line?: string;
}

// The this-is-me glance (Today only, top of screen): avatar + name + an
// optional read-only line. A glance, not a form — nothing here is
// editable and nothing here is instructional copy.
export function GlanceHeader({ name, line }: GlanceHeaderProps) {
  return (
    <div class="glance-header">
      <div class="glance-header__avatar" aria-hidden="true" />
      <div class="glance-header__body">
        <div class="glance-header__name">{name}</div>
        {line ? <div class="glance-header__line">{line}</div> : null}
      </div>
    </div>
  );
}
